import { GpPersonaType } from '../enum/gp-persona-type.enum';
import { TranslationKeyMap } from '../gp-main.i18n';
import { ConstPersona } from '../model/const-persona.model';

export const gpPersonas = new Map<GpPersonaType, ConstPersona>();

gpPersonas.set(GpPersonaType.NEEDS_COACHING, {
    containerClassList: 'cmps-gp-border-color-pa-needs-coaching-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-needs-coaching-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-needs-coaching-bg',
        'cmps-gp-color-pa-needs-coaching-text',
    ].join(' '),
    icon: 'alert-circle-outline',
    iconFill: 'cmps-gp-fill-pa-needs-coaching-text',
    label: TranslationKeyMap._11283_COACHING_REQUIRED,
    description: TranslationKeyMap._11328_DESC_NEEDS_COACHING,
    tagline: TranslationKeyMap._11305_TAGLINE_NEEDS_COACHING,
});

gpPersonas.set(GpPersonaType.COACHING_REVIEW, {
    containerClassList: 'cmps-gp-border-color-pa-coaching-review-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-coaching-review-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-coaching-review-bg',
        'cmps-gp-color-pa-coaching-review-text',
    ].join(' '),
    icon: 'alert-outline',
    iconFill: 'cmps-gp-fill-pa-coaching-review-text',
    label: TranslationKeyMap._11284_REVIEW_ACTIVE_COACHING,
    description: TranslationKeyMap._11329_DESC_COACHING_REVIEW,
    tagline: TranslationKeyMap._11306_TAGLINE_COACHING_REVIEW,
});

gpPersonas.set(GpPersonaType.IMPROVING_COACHING, {
    containerClassList: 'cmps-gp-border-color-pa-improving-coaching-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-improving-coaching-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-improving-coaching-bg',
        'cmps-gp-color-pa-improving-coaching-text',
    ].join(' '),
    icon: 'alert-box-outline',
    iconFill: 'cmps-gp-fill-pa-improving-coaching-text',
    label: TranslationKeyMap.__IMPROVING_COACHING,
    description: TranslationKeyMap.__DESC_IMPROVING,
    tagline: TranslationKeyMap.__TAGLINE_IMPROVING,
});

gpPersonas.set(GpPersonaType.SUCCESSFUL_COACHING, {
    containerClassList: 'cmps-gp-border-color-pa-successful-coaching-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-successful-coaching-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-successful-coaching-bg',
        'cmps-gp-color-pa-successful-coaching-text',
    ].join(' '),
    icon: 'check-circle-outline',
    iconFill: 'cmps-gp-fill-pa-successful-coaching-text',
    label: TranslationKeyMap._11285_SUCCESSFUL_COACHING,
    description: TranslationKeyMap._11330_DESC_SUCCESSFUL_COACHING,
    tagline: TranslationKeyMap._11307_TAGLINE_SUCCESSFUL,
});

gpPersonas.set(GpPersonaType.COACHING_RAMP, {
    containerClassList: 'cmps-gp-border-color-pa-coaching-ramp-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-coaching-ramp-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-coaching-ramp-bg',
        'cmps-gp-color-pa-coaching-ramp-text',
    ].join(' '),
    icon: 'clock-outline',
    iconFill: 'cmps-gp-fill-pa-coaching-ramp-text',
    label: TranslationKeyMap.__COACHING_RAMP,
    description: TranslationKeyMap.__DESC_COACHING_RAMP,
    tagline: TranslationKeyMap.__TAGLINE_COACHING_RAMP,
});

gpPersonas.set(GpPersonaType.ON_TRACK, {
    containerClassList: 'cmps-gp-border-color-pa-on-track-border',
    headerClassList: 'cmps-gp-bg-gradient-pa-on-track-grad',
    rowClassList: [
        'cmps-gp-bg-color-pa-on-track-bg',
        'cmps-gp-color-pa-on-track-text',
    ].join(' '),
    icon: 'account-multiple-outline',
    iconFill: 'cmps-gp-fill-pa-on-track-text',
    label: TranslationKeyMap._11286_ON_TRACK,
    description: TranslationKeyMap._11331_DESC_ON_TRACK,
    tagline: TranslationKeyMap._11308_TAGLINE_ON_TRACK,
});
